export interface clientLandRoleEntity {
  name: string;
  countries: {
    id: string;
    name: string;
  }[];
  roles: {
    id: string;
    name: string;
  }[];
}

export const LAND_ROLE_VIEW_KEY = 'landRoleView';

export interface LandRoleView {
  countryId: string | null;
  roleId: string | null;
}
